import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { DateRangeKey } from 'store/datePeriodAtom';

export const isAddVehiclesToChartModalOpenAtom = atomWithStorage<boolean>(
  'vin-manager-vvo-add-vehicles-to-chart-modal-open',
  false,
);

export const vvoDatePeriodAtom = atom<DateRangeKey>('Past 30 Days');

export const selectedVinsAtom = atom<string[]>([]);
